import React, { useState, useEffect } from "react";

import styles from "./Hoticulture.module.css";
import Image_one from "../../assets/pexels-soo.png";
import Image_two from "../../assets/overhead-view.png";
import Image_three from "../../assets/pexels-wendy-wei.png";
import Frame from "../../assets/Frame-1.png";
import frames from "../../assets/Frame.png";
import { api_call, api_call_token } from "../../utils/Network";

function Hoticulture() {
  const [displayData, setDisplayData] = useState({ point: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    api_call.get(`service_list/horticulture/`).then((response) => {
      setDisplayData(response.data.data);
    });
  };

  return (
    <div style={{ backgroundColor: "#490550", paddingBottom: "10%" }}>
      <div className={styles.main}>
        <div className={styles.head}>
          <h1
            style={{ whiteSpace: "nowrap", color: "#eeceef", margin: "10px 0" }}
          >
            Upcoming Ventures
          </h1>
        </div>
        <div>
          <div className={styles.content_flex}>
            <div className={styles.box_one}>
              <img src={Image_one} alt="Image-one" className={styles.images} />
            </div>
            <div className={styles.box_two}>
              <h2 className={styles.pink}>Horticulture</h2>
              <p className={styles.pink}>
                A Unique team of farmers to biologists passionately working to
                upkeep the environment and botanical aura in and around homes,
                gardens and facilities green, fresh and rejuvenating through all
                seasons in a customised manner to suit Commercial or Residential
                needs.
              </p>
            </div>
          </div>
          <div className={styles.leafs}>
            <img
              style={{ position: "relative", zIndex: 1 }}
              src={Image_two}
              alt="image_two"
              className={styles.images}
            />
            <img src={frames} alt="leaf" className={styles.leaf_one} />
          </div>
          {/* <div className={styles.content_flex}>
            <div className={styles.box_two}>
              <h2 className={styles.pink}>Horticulture</h2>
              <p className={styles.pink}>
                A Unique team of farmers to biologists passionately working to
                upkeep the environment and botanical aura in and around homes,
                gardens and facilities green, fresh and rejuvenating through all
                seasons in a customised manner to suit Commercial or Residential
                needs.
              </p>
            </div>
            <div className={styles.box_one}>
              <img src={Image_one} alt="Image-one" className={styles.images} />
            </div>
          </div> */}
          {/* <div className={styles.content_flex}>
            <div className={styles.box_two} style={{ position: "relative" }}>
              {[1, 2].map((x, i) => (
                <p key={i} className={styles.pink}>
                  Lorem ipsum dolar sit amet, consectetur adipiscing elit.
                  Tincidunt facilisis nuncLorem ipsum dolar sit amet,
                  consectetur adipiscing elit. Tincidunt facilisis nunc
                </p>
              ))}
              <img src={Frame} alt="frame_left" className={styles.leaf_two} />
            </div>
            <div className={styles.box_one}>
              <img
                src={Image_three}
                alt="Image-three"
                className={styles.images}
                style={{ position: "relative" }}
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Hoticulture;
